import { privateApi } from '@/config/axios.config';

export interface CompanyTaxInfo {
    id: string;
    tenantId: string;
    rnc: string;
    companyName: string;
    commercialName?: string;
    address: string;
    city: string;
    state: string;
    country: string;
    zipCode?: string;
    phone?: string;
    email?: string;
    website?: string;
    defaultItbisRate?: number;
    applyItbis?: boolean;
    // ... add other fields as needed
}

export const taxInfoApiService = {
    getTaxInfo: async (): Promise<CompanyTaxInfo> => {
        const response = await privateApi.get('/financial/tax-info');
        return response.data?.data || response.data;
    },

    createTaxInfo: async (data: Partial<CompanyTaxInfo>): Promise<CompanyTaxInfo> => {
        const response = await privateApi.post('/financial/tax-info', data);
        return response.data?.data || response.data;
    },

    updateTaxInfo: async (data: Partial<CompanyTaxInfo>): Promise<CompanyTaxInfo> => {
        const response = await privateApi.patch('/financial/tax-info', data);
        return response.data?.data || response.data;
    },
};
